/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable, TemplateRef} from '@angular/core';
import {AuthService} from 'compob2b-auth';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {translations} from '../../../environments/translations.ru';
import {Columns} from 'compob2b-table';

@Injectable({
  providedIn: 'root'
})
/**
 * The service prepares configuration for ngx-easy-grid and ngx-formly
 * Configuration is CompoColumns type in each module's config constant
 */
export class FormConfigService {

  private columnsConfig: Columns[];
  private pictureConfig: Columns[];

  constructor(private readonly authService: AuthService) {
  }

  /**
   * Component sets config from constant configuration
   * @param config
   */
  setConfig(config: Columns[]): FormConfigService {
    this.columnsConfig = config;
    return this;
  }

  /**
   * Sets custom cell template for ngx-easy-grid column
   * @param field
   * @param template
   */
  setGridCellTemplate(field: string, template: TemplateRef<any>): FormConfigService {
    this.columnsConfig.filter(item => item.key === field).forEach(item => item.cellTemplate = template);
    return this;
  }

  formly(all = false): FormConfigService {
    const isSuperAdmin = this.authService.isSuperAdmin();

    this.columnsConfig
      .forEach(item => {
        if (!item.templateOptions) {
          item.templateOptions = {
            required: item.required,
            placeholder: item.placeholder,
            label: item.title
          }
        }

        if (item.templateOptions.label === undefined) {
          item.templateOptions.label = item.title;
        }
        if (item.templateOptions.required === undefined) {
          item.templateOptions.required = item.required;
        }
      });
    this.pictureConfig = this.columnsConfig.filter(item => item.picture);

    if (!all) {
      this.checkVisibility()
      this.columnsConfig = this.columnsConfig.filter(item => item.formly);
    }

    this.columnsConfig.filter(item => item.key === 'roles').forEach(item => item.templateOptions.disabled = !isSuperAdmin);

    return this;
  }

  private checkVisibility() {
    this.columnsConfig.forEach((item) => {
      if (!item.formly && !item.grid && item['key'] != 'pictureInput') {
        console.error(item);
      }
    })
  }

  /**
   * Adds multiple options for checkboxes asynchronously
   * @param field
   * @param asyncResult
   */
  addMultipleOptions(field: string, asyncResult: Observable<any>): FormConfigService {

    const checkedAsyncPipe = asyncResult.pipe(map(list => this.checkDeleted(list)));

    this.columnsConfig.filter(item => item.key === field)
      .forEach(item => item.templateOptions.options = checkedAsyncPipe);
    return this;
  }

  grid(): FormConfigService {
    this.checkVisibility();

    this.columnsConfig = this.columnsConfig.filter(item => item.grid === true);
    return this;
  }

  getConfig(): Columns[] {
    return this.columnsConfig;
  }

  getPictureConfig(): Columns[] {
    return this.pictureConfig;
  }

  private checkDeleted(list: any): any {
    list?.filter(elem => elem.deleted === true).map(elem => elem.header += ' (' + translations.deleted + ')');
    return list;
  }
}
